export default function SectorSection({
                                          title,
                                          badge,
                                          subtitle,
                                          description,
                                          features = [],
                                          imageSrc,
                                          reverse = false
                                      }) {
    return (
        <section className="sector-area pt-60 pb-80 position-relative overflow-hidden">
            <div className="container px-2 position-relative" style={{ zIndex: 2 }}>
                <div className={`row align-items-center g-5 ${reverse ? 'flex-row-reverse' : ''}`} style={{
                    backgroundImage: 'url("21.png")',
                    backgroundSize: '',
                    backgroundPosition: 'center',
                    backgroundColor: '#ffffff'
                }}>
                    {/* Left/Right Text Content */}
                    <div className="col-lg-6" >
                        <div className="sector-content">
                            <h2 className="fw-bold mb-3" style={{ color: '#0f172a' }}>{title}</h2>
                            {badge && (
                                <span className="badge bg-dark text-white border px-3 py-2 mb-3 fw-semibold rounded-pill">
                                    {badge}
                                </span>
                            )}
                            {subtitle && <h3 className="fw-bold mb-3 text-dark fs-4">{subtitle}</h3>}
                            {description && (
                                <p className="text-dark mb-4" align="justify">
                                    {description}
                                </p>
                            )}

                            <ul className="list-unstyled">
                                {features.map((item, index) => (
                                    <li key={index} className="d-flex align-items-center mb-3">
                                        <div className="flex-shrink-0 text-primary fs-5 me-3">
                                            <i className={item.icon || "fa fa-check-circle"}></i>
                                        </div>
                                        <span className="text-dark fw-medium">{item.text}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Image Side */}
                    <div className="col-lg-6">
                        <div className="sector-img text-center">
                            <img
                                src={imageSrc}
                                alt={title}
                                className="img-fluid w-100 shadow-sm"
                                style={{ borderRadius: '40px', objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}